import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';
import { _ } from '../../domain/languageSlice';
import { useState } from 'react';
import { api } from '../../maps/data.js';

import { useEffect } from 'react';
import EdgeCardForSelect from '../EdgeCardForSelect';

export default function DistributorAddEdgeToInstallerDialog(props) {
    let { open, onClose } = props;

    const [edges, s_edges] = useState([]);

    const getEdges = async () => {
        const edges_res = await api({ type: 'getEdges', data: { noInstallers: true } });
        s_edges(edges_res.map(edge => ({ ...edge, deviceTypeLabel: _(`device.${edge.deviceType.replace(/_/g, '').toLowerCase()}`) })));
    }

    useEffect(() => {
        getEdges();
    }, []);

    const add = async (edgeId) => {
        await api({
            type: 'distributorAddEdgeToInstaller',
            data: {
                edgeId,
                installerId: props.installer._id
            }
        });
        onClose();
    }

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth={true}>
            <DialogTitle id="alert-dialog-title">
                <Tx>edge.distributorAddEdgeToInstaller.title</Tx>
            </DialogTitle>
            <DialogContent style={{ paddingTop: 5 }}>
                {
                    edges.map(edge => <EdgeCardForSelect key={edge._id} edge={edge} onSelect={edgeId => add(edgeId)}/>)
                }
            </DialogContent>
        </Dialog>)
}